import SingleCard from "../../../components/Reusable/SingleCard";
import {
  totalLeaveRequest,
  totalLeaveApproved,
  totalLeaveRequestPending,
} from "../../../components/Reusable/CardData";

export default function LeaveSummaryCards({
  totalLeaveRequests,
  totalLeavesApproved,
  totalLeavePending,
  onCardClick,
}) {
  return (
    <div className="grid grid-cols-3 gap-3">
      <div
        onClick={() =>
          onCardClick("/totalleaverqttable", "requestedLeavesToday")
        }
      >
        <SingleCard
          item={{
            ...totalLeaveRequest,
            count: totalLeaveRequests,
            linkTo: "/totalleaverqttable",
          }}
        />
      </div>

      <div
        onClick={() =>
          onCardClick("/leaveapprovedtable", "approvedLeaves")
        }
      >
        <SingleCard
          item={{
            ...totalLeaveApproved,
            count: totalLeavesApproved,
            linkTo: "/leaveapprovedtable",
          }}
        />
      </div>

      <div
        onClick={() =>
          onCardClick("/pendingleaverqttable", "pendingLeaves")
        }
      >
        <SingleCard
          item={{
            ...totalLeaveRequestPending,
            count: totalLeavePending,
            linkTo: "/pendingleaverqttable",
          }}
        />
      </div>
    </div>
  );
}